import {
	Environment,
	Network,
	RecordSource,
	Store,
	commitLocalUpdate,
	QueryResponseCache
} from "relay-runtime";
import { GC_AUTH_TOKEN } from "./constants";

const oneMinute = 1000 * 60;
const cache = new QueryResponseCache({ size: 250, ttl: oneMinute });
const { REACT_APP_GRAPHQL_API } = process.env;

// Implement the cache strategey bellow:
function fetchQuery(operation, variables, cacheConfig) {
	const queryID = operation.text;
	// const isMutation = operation.operationKind === "mutation";
	const isQuery = operation.operationKind === "query";
	const forceFetch = cacheConfig && cacheConfig.force;

	// Try to get data from cache on queries
	const fromCache = cache.get(queryID, variables);
	if (isQuery && fromCache !== null && !forceFetch) {
		return fromCache;
	}

	// Otherwise fetch data from the server
	return fetch(REACT_APP_GRAPHQL_API, {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
			"Authorization": `JWT ${localStorage.getItem(GC_AUTH_TOKEN)}` 
		},
		body: JSON.stringify({
			query: operation.text,
			variables
		})
	}).then(response => {
		return response.json();
	});
}

const environment = new Environment({
	network: Network.create(fetchQuery),
	store: new Store(new RecordSource())
});

commitLocalUpdate(environment, store => {
	const fieldKey = "settings";
	const __typename = "Settings";

	const dataID = `client:${__typename}`;
	const record = store.create(dataID, __typename);
	record.setValue(false, "isAuthenticated");
	record.setValue('', "userId");
	record.setValue(false, "isNavActivated");
	record.setValue([""], "selectedSourceId");
	record.setValue('', "selectedParentId");
	record.setValue('{}', "treeStates");
	record.setValue(true, "isParent");
	record.setValue([""], "selectedNodeId");
	record.setValue('', "selectedPostId");


	environment.retain({
		request: {},
		root: {
			dataID,
			variables: {},
			node: { selections: [] }
		}
	});

	store.getRoot().setLinkedRecord(record, fieldKey);
});


export default environment;
